// Import general mixin for shared functionality.
import mixin from './mixin';

// Maps library
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet';

// Fuzzy search module
import Fuse from 'fuse.js';

const fuseOptions = {
    shouldSort: false,
    keys: [
        'Name',
        'Type',
        'Region',
        'Straat',
        'Plaats',
    ]
};

const locationWaitingtimesApp = {
    mixins: [mixin],
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
    },
    data() {
        return {
            dataLocations: null,
            searchText: '',
            selectedRegion: '',
            selectedType: '',
            zoom: 8, // Set to zoom to Amsterdam/Utrecht
            center: [52.2995, 5.2434], // Set to center of the Netherlands
        };
    },
    computed: {
        filteredLocations() {
            if (!this.dataLocations) return [];
            let results = [...this.dataLocations];
            if (this.searchText) {
                const fuse = new Fuse(results, fuseOptions);
                results = fuse.search(this.searchText).map(result => result.item);
            }
            if (this.selectedRegion) {
                results = results.filter(location => location.Region === this.selectedRegion);
            }
            if (this.selectedType) {
                results = results.filter(location => location.Type.includes(this.selectedType));
            }
            return results.sort((a, b) => a.Name - b.Name);
        },
        regions() {
            if (!this.dataLocations) return [];
            return this.removeDuplicates(this.dataLocations.map(location => location.Region)).sort((a, b) => a - b);
        },
        types() {
            if (!this.dataLocations) return [];
            let types = [];
            this.dataLocations.forEach(location => {
                if (location.Type) JSON.parse(location.Type).forEach(type => types.push(type))
            });
            return this.removeDuplicates(types).sort((a, b) => a - b);
        },
        filtersActive() {
            return this.searchText || this.selectedRegion || this.selectedType;
        }
    },
    methods: {
        openDropdown(ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.add('is-active');

                document.addEventListener('click', (event) => {
                    if (!this.$refs[ref].contains(event.target)) {
                        this.$refs[ref].classList.remove('is-active');
                    }
                });
            }
        },
        setRegion(region, ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.remove('is-active');
            }
            this.selectedRegion = region;
            const url = new URL(location);
            url.searchParams.set('region', this.selectedRegion);
            if (!this.selectedRegion) url.searchParams.delete('region');
            history.pushState({}, '', url);
        },
        setType(type, ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.remove('is-active');
            }
            this.selectedType = type;
            const url = new URL(location);
            url.searchParams.set('type', this.selectedType);
            if (!this.selectedType) url.searchParams.delete('type');
            history.pushState({}, '', url);
        },
        resetFilters() {
            this.setRegion('');
            this.setType('');
            this.searchText = '';
            const url = new URL(location);
            url.searchParams.delete('region');
            url.searchParams.delete('type');
            url.searchParams.delete('q');
            history.pushState({}, '', url);
        },
        updateMap() {
            const width = window.innerWidth;
            switch (true) {
                case width < 833:
                    this.zoom = 8;
                    break;
                case width < 1024:
                    this.zoom = 9;
                    break;
                default:
                    this.zoom = 10;
                    break;
            }
            if (this.$refs.map) this.$refs.map.leafletObject.panTo(this.center);
        }
    },
    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('q')) this.searchText = urlParams.get('q');
        if (urlParams.has('region')) this.selectedRegion = urlParams.get('region');
        if (urlParams.has('type')) this.selectedType = urlParams.get('type');

        this.changeSearchText = this.debounce(event => {
            const url = new URL(location);
            url.searchParams.set('q', this.searchText);
            if (!this.searchText) url.searchParams.delete('q');
            history.pushState({}, '', url);
        });

        this.updateMap();
        this.changeScreenSize = this.debounce(event => {
            this.updateMap();
        });
        window.addEventListener('resize', this.changeScreenSize);
    },
    mounted() {
        if (this.$el.dataset.locations) this.dataLocations = JSON.parse(this.$el.dataset.locations);
        this.dataLocations = this.dataLocations.filter(location => !parseInt(location.HideInOverview));
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.changeScreenSize);
    },
};

export default locationWaitingtimesApp;
